var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "accordion-group",
    { ref: "accordion-group", staticClass: "product-details" },
    [
      _vm.product.description
        ? _c(
            "accordion",
            {
              attrs: {
                heading: "Product Details",
                id: "product-details-accordion",
                selected: true,
                "auto-close": false,
                theme: "footer-bourdain"
              }
            },
            [
              _c(
                "span",
                {
                  staticClass: "h6 product-details__heading",
                  attrs: { slot: "heading" },
                  slot: "heading"
                },
                [_vm._v("Product Details")]
              ),
              _c(
                "accordion-tease",
                {
                  attrs: {
                    "on-tease-expand": _vm.onTeaseExpand,
                    "collapsed-height": 314
                  }
                },
                [
                  _c("div", {
                    staticClass: "client-generated scrolling-text__content",
                    domProps: { innerHTML: _vm._s(_vm.product.description) }
                  })
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm.jsonDesignerCollection
        ? _c(
            "accordion",
            {
              ref: "designer-details-accordion",
              attrs: {
                heading: "Designer details",
                id: "product-details-accordion",
                selected: false,
                "auto-close": false,
                theme: "footer-bourdain"
              }
            },
            [
              _c(
                "span",
                {
                  staticClass: "h6 product-details__heading",
                  attrs: { slot: "heading" },
                  slot: "heading"
                },
                [_vm._v("Designer details")]
              ),
              _c(
                "accordion-tease",
                {
                  attrs: {
                    "on-tease-expand": _vm.onTeaseExpand,
                    "collapsed-height": 314
                  }
                },
                [
                  _c("div", {
                    staticClass: "client-generated scrolling-text__content",
                    domProps: {
                      innerHTML: _vm._s(_vm.jsonDesignerCollection.description)
                    }
                  })
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm.settings.accordionContent
        ? _c(
            "accordion",
            {
              attrs: {
                heading: _vm.settings.accordionName,
                theme: "footer-bourdain",
                "auto-close": false
              }
            },
            [
              _c(
                "span",
                {
                  staticClass: "h6 product-details__heading",
                  attrs: { slot: "heading" },
                  slot: "heading"
                },
                [_vm._v(_vm._s(_vm.settings.accordionName))]
              ),
              _c(
                "accordion-tease",
                {
                  attrs: {
                    "on-tease-expand": _vm.onTeaseExpand,
                    "collapsed-height": 314
                  }
                },
                [
                  _c("div", {
                    staticClass: "client-generated scrolling-text__content",
                    domProps: {
                      innerHTML: _vm._s(_vm.settings.accordionContent)
                    }
                  })
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm.customFields.d2_download_link_url &&
      _vm.customFields.d2_download_link_text
        ? _c(
            "div",
            { staticClass: "flex align-center product-details__download" },
            [
              _c("icon", { attrs: { name: "save_alt", size: "16px" } }),
              _c(
                "v-link",
                {
                  attrs: {
                    primary: "",
                    href: _vm.customFields.d2_download_link_url,
                    download: ""
                  }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.customFields.d2_download_link_text))
                  ])
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }